import { render, staticRenderFns } from "./ConfirmDefault.vue?vue&type=template&id=37f5caca"
import script from "./ConfirmDefault.vue?vue&type=script&lang=js"
export * from "./ConfirmDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports